import React from 'react'
import { Button } from 'shards-react'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import addFont from '../../../../fonts/fonts'
import styles from '../styles.module.css'
import { METRICS_TOP, METRICS_MONITORING, MONITORING_SECTION_TITLE, fmt } from './metrics'


const orientation = 'p'
const fileTitle = 'Отчет об успеваемости (форма №2СВУ)'


export default function Buttons ({ visible, data }) {

  const buildBody = (row) => {
    const top = METRICS_TOP.map(m => [m.label, fmt(row[m.key])])
    const monitoring = METRICS_MONITORING.map(m => [m.label, fmt(row[m.key])])
    return [
      ...top,
      [{
        content: MONITORING_SECTION_TITLE,
        colSpan: 2,
        styles: { halign: 'center', fontStyle: 'bold', fillColor: [240, 244, 255], textColor: [0, 112, 192] },
      }],
      ...monitoring,
    ]
  }

  const getPdfData = async () => {
    addFont(jsPDF.API)
    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation })

    const { width } = doc.internal.pageSize
    const margin = 14

    doc.setFont('Montserrat')

    const rows = data?.rows || []
    const academicYear = data?.academicYear
    const yearTitle = academicYear
      ? `в ${academicYear} учебном году`
      : 'за учебный год'

    rows.forEach((row, index) => {
      if (index > 0) doc.addPage('a4', orientation)

      let y = 12

      doc.setFontSize(9)
      doc.setFont('Montserrat', 'bold')
      doc.text('Министерство обороны Российской Федерации', width / 2, y, { align: 'center' })
      y += 4
      doc.text('Департамент военного образования', width / 2, y, { align: 'center' })
      doc.setFont('Montserrat', 'normal')
      y += 6

      doc.setFontSize(10)
      doc.text('Форма №2/СВУ', width - margin, y, { align: 'right' })

      const sideLabelReserve = 70

      doc.setFontSize(11)
      const titleLines = doc.splitTextToSize(
        `Сведения об успеваемости и качестве учебы ${yearTitle}`,
        width - margin * 2 - sideLabelReserve,
      )
      titleLines.forEach(line => {
        doc.text(line, width / 2, y, { align: 'center' })
        y += 6
      })

      doc.setFontSize(10)
      doc.text('Таблица №1', width - margin, y, { align: 'right' })

      if (row.organizationName) {
        doc.setFontSize(11)
        const orgLines = doc.splitTextToSize(row.organizationName, width - margin * 2 - sideLabelReserve)
        orgLines.forEach(line => {
          doc.text(line, width / 2, y, { align: 'center' })
          y += 6
        })
      }

      y += 2

      doc.autoTable({
        startY: y,
        body: buildBody(row),
        margin: { left: margin, right: margin },
        styles: { font: 'Montserrat', fontSize: 9, cellPadding: 2, lineWidth: 0.1, lineColor: 200 },
        columnStyles: {
          0: { halign: 'left' },
          1: { halign: 'right', cellWidth: 30 },
        },
      })
    })

    return doc
  }

  const toPdf = () => {
    getPdfData().then(doc => doc.save(`${fileTitle}.pdf`))
  }

  if (!visible) return null

  return (
    <div className={styles.buttonsBlock}>
      <Button theme='danger' className={'mb-2'} onClick={toPdf}>
        Скачать .pdf
      </Button>
    </div>
  )
}
